// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3BOdG","emails":"CreateEditClinics_emails__RaYaJ","emailTagLabel":"CreateEditClinics_emailTagLabel__30tMf"};